import { inject, Injectable } from '@angular/core';
import { ApiService } from '@app/gateway';
import { from, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ClienteModel } from '../models';
import { StoreService } from './store.service';

@Injectable({
  providedIn: 'root',
})
export class ClienteService {
  private readonly accountService = inject(StoreService);
  private readonly apiService = inject(ApiService);

  getCliente(value: string): Observable<ClienteModel | null> {
    const cleanValue = value.replace(/[^\d]/g, '');
    const storeName = this.accountService.getStoreName();
    const path = `sync/clientes/${storeName}/${cleanValue}`;
    return from(this.apiService.get<ClienteModel>({ path })).pipe(
      map((response: any) => {
        const clienteData = response[0] || response;
        return clienteData;
      }),
      catchError((error) => {
        console.error('Erro ao buscar cliente:', error);
        return of(null);
      })
    );
  }

  async getClienteValidacao(value: string, phone: string): Promise<ClienteModel> {
    const cleanValue = value.replace(/[^\d]/g, '');
    const storeName = this.accountService.getStoreName();
    const path = `sync/cliente/validacao/${storeName}/${cleanValue}/${phone}`;
    const cliente = await this.apiService.get<ClienteModel>({ path });
    console.log(cliente);
    return cliente;
  }
}
